import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment";
import $ from "jquery";
import { HoraireHebdoDto } from "../../../dto/GenApi.iNotPaie.Dto/HoraireHebdoDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalHoraireHebdo extends Vue {
    public horaireHebdo: HoraireHebdoDto = { Id: 0, HoraireJourneeLundi: { Id: 0 }, HoraireJourneeMardi: { Id: 0 }, HoraireJourneeMercredi: { Id: 0 }, HoraireJourneeJeudi: { Id: 0 }, HoraireJourneeVendredi: { Id: 0 }, HoraireJourneeSamedi: { Id: 0 } };
    public entreeSalarieId: number | undefined = undefined;
    public contratSalarieId: number | undefined = undefined;

    public totalMatinLundi = "";
    public totalMatinMardi = "";
    public totalMatinMercredi = "";
    public totalMatinJeudi = "";
    public totalMatinVendredi = "";
    public totalMatinSamedi = "";

    public totalApremLundi = "";
    public totalApremMardi = "";
    public totalApremMercredi = "";
    public totalApremJeudi = "";
    public totalApremVendredi = "";
    public totalApremSamedi = "";

    public totalJourneeLundi = "";
    public totalJourneeMardi = "";
    public totalJourneeMercredi = "";
    public totalJourneeJeudi = "";
    public totalJourneeVendredi = "";
    public totalJourneeSamedi = "";

    public totalSemaine = "";

    public initContratSalarie(idContrat: number) {

        this.contratSalarieId = idContrat;
        
        ServicesFactoryInstance.HoraireHebdoService.getHoraireHebdoContrat(idContrat, data => {
            this.setHoraireHebdo(data);          
        }, () => { this.setHoraireHebdo(undefined); });
    }

    public initEntreeSalarie(idEntreeSalarie: number, horaireHebdo?: HoraireHebdoDto) {

        this.entreeSalarieId = idEntreeSalarie;
        this.setHoraireHebdo(horaireHebdo);
    }

    public setHoraireHebdo(horaire?: HoraireHebdoDto) {
        if (horaire === null || horaire === undefined) {

            this.horaireHebdo = {
                Id: 0,
                HoraireJourneeLundi: { Id: 0 },
                HoraireJourneeMardi: { Id: 0 },
                HoraireJourneeMercredi: { Id: 0 },
                HoraireJourneeJeudi: { Id: 0 },
                HoraireJourneeVendredi: { Id: 0 },
                HoraireJourneeSamedi: { Id: 0 }
            };
        } else {
            this.horaireHebdo = JSON.parse(JSON.stringify(horaire));
        }
        this.calculerTotaux();
        $("#modalHoraireHebdo").modal({ backdrop: "static" });
        $("#modalHoraireHebdo").modal("show");
    }

    public valider(): void {
        if (this.contratSalarieId != undefined && this.horaireHebdo != undefined) {
            // planning validé via la page contrat
            ServicesFactoryInstance.HoraireHebdoService.addOrUpdateHoraireHebdoContrat(this.contratSalarieId, this.horaireHebdo, data => {
                NotificationServiceInstance.SendSuccess("Le calendrier du salarié a été enregistré");
                this.horaireHebdo = data;
                this.$emit("horaireHebdoContratUpdated", this.contratSalarieId, this.horaireHebdo.Id);
            }, () => {
                NotificationServiceInstance.SendFailed("L'enregistrement du calendrier a échoué");
            });
        } else if (this.entreeSalarieId != undefined && this.entreeSalarieId > 0 && this.horaireHebdo != undefined) {
            // planning validé via une entrée salarié déjà enregistrée
            ServicesFactoryInstance.HoraireHebdoService.addOrUpdateHoraireHebdoEntreeSalarie(this.entreeSalarieId, this.horaireHebdo, data => {
                NotificationServiceInstance.SendSuccess("Le calendrier du salarié a été enregistré");
                this.horaireHebdo = data;
                this.$emit("horaireHebdoUpdated", this.horaireHebdo);
            }, () => {
                NotificationServiceInstance.SendFailed("L'enregistrement du calendrier a échoué");
            });
        } else if (this.entreeSalarieId === 0 && this.horaireHebdo != undefined) {
            // planning validé mais entrée pas encore enregistrée
            this.$emit("horaireHebdoUpdated", this.horaireHebdo);
        }

        this.close();
    }

    public dataChanged() {
        this.calculerTotaux();
    }

    public reinitialiser() {
        this.horaireHebdo = {
            Id: this.horaireHebdo?.Id ?? 0,
            HoraireJourneeLundi: { Id: this.horaireHebdo?.HoraireJourneeLundi.Id ?? 0 },
            HoraireJourneeMardi: { Id: this.horaireHebdo?.HoraireJourneeMardi.Id ?? 0 },
            HoraireJourneeMercredi: { Id: this.horaireHebdo?.HoraireJourneeMercredi.Id ?? 0 },
            HoraireJourneeJeudi: { Id: this.horaireHebdo?.HoraireJourneeJeudi.Id ?? 0 },
            HoraireJourneeVendredi: { Id: this.horaireHebdo?.HoraireJourneeVendredi.Id ?? 0 },
            HoraireJourneeSamedi: { Id: this.horaireHebdo?.HoraireJourneeSamedi.Id ?? 0 }
        };
        this.dataChanged();
        this.$forceUpdate();
    }

    public annuler(): void {
        this.close();
    }

    private close(): void {
        $("#modalHoraireHebdo").modal("hide");
    }

    private calculerTotaux() {
        this.totalMatinLundi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeLundi?.MatinDebut, this.horaireHebdo?.HoraireJourneeLundi?.MatinFin);
        this.totalMatinMardi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeMardi?.MatinDebut, this.horaireHebdo?.HoraireJourneeMardi?.MatinFin);
        this.totalMatinMercredi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeMercredi?.MatinDebut, this.horaireHebdo?.HoraireJourneeMercredi?.MatinFin);
        this.totalMatinJeudi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeJeudi?.MatinDebut, this.horaireHebdo?.HoraireJourneeJeudi?.MatinFin);
        this.totalMatinVendredi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeVendredi?.MatinDebut, this.horaireHebdo?.HoraireJourneeVendredi?.MatinFin);
        this.totalMatinSamedi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeSamedi?.MatinDebut, this.horaireHebdo?.HoraireJourneeSamedi?.MatinFin);

        this.totalApremLundi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeLundi?.ApremDebut, this.horaireHebdo?.HoraireJourneeLundi?.ApremFin);
        this.totalApremMardi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeMardi?.ApremDebut, this.horaireHebdo?.HoraireJourneeMardi?.ApremFin);
        this.totalApremMercredi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeMercredi?.ApremDebut, this.horaireHebdo?.HoraireJourneeMercredi?.ApremFin);
        this.totalApremJeudi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeJeudi?.ApremDebut, this.horaireHebdo?.HoraireJourneeJeudi?.ApremFin);
        this.totalApremVendredi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeVendredi?.ApremDebut, this.horaireHebdo?.HoraireJourneeVendredi?.ApremFin);
        this.totalApremSamedi = this.getTimeDifference(this.horaireHebdo?.HoraireJourneeSamedi?.ApremDebut, this.horaireHebdo?.HoraireJourneeSamedi?.ApremFin);

        this.totalJourneeLundi = this.getTotalJournee(this.totalMatinLundi, this.totalApremLundi);
        this.totalJourneeMardi = this.getTotalJournee(this.totalMatinMardi, this.totalApremMardi);
        this.totalJourneeMercredi = this.getTotalJournee(this.totalMatinMercredi, this.totalApremMercredi);
        this.totalJourneeJeudi = this.getTotalJournee(this.totalMatinJeudi, this.totalApremJeudi);
        this.totalJourneeVendredi = this.getTotalJournee(this.totalMatinVendredi, this.totalApremVendredi);
        this.totalJourneeSamedi = this.getTotalJournee(this.totalMatinSamedi, this.totalApremSamedi);

        this.totalSemaine = this.getTotalSemaine();
    }

    private getTimeDifference(t1: Date | undefined, t2: Date | undefined): string {
        if (t1 === undefined || t2 === undefined) {
            return "";
        }

        const heureDebut = moment(t1);
        const heureFin = moment(t2);

        const duree = moment(heureFin).subtract({
            hours: heureDebut.hours(),
            minutes: heureDebut.minutes()
        }).format("HH:mm");

        return duree == "Invalid date" ? "" : duree;
    }

    private getTotalJournee(tempsMatin: string, tempsAprem: string): string {
        if (tempsMatin === "") {
            tempsMatin = "00:00";
        }
        if (tempsAprem === "") {
            tempsAprem = "00:00";
        }

        const totalJournee = moment(new Date(2022, 0, 1));
        const splitTempsMatin = tempsMatin.split(":").map(item => parseInt(item) || 0);
        const splitTempsAprem = tempsAprem.split(":").map(item => parseInt(item) || 0);

        totalJournee.hours(splitTempsMatin[0] + splitTempsAprem[0]).minutes(splitTempsMatin[1] + splitTempsAprem[1]);

        return totalJournee.format("HH:mm");
    }

    private getTotalSemaine() {
        const splitTotalLundi = this.totalJourneeLundi.split(":").map(item => parseInt(item));
        const splitTotalMardi = this.totalJourneeMardi.split(":").map(item => parseInt(item));
        const splitTotalMercredi = this.totalJourneeMercredi.split(":").map(item => parseInt(item));
        const splitTotalJeudi = this.totalJourneeJeudi.split(":").map(item => parseInt(item));
        const splitTotalVendredi = this.totalJourneeVendredi.split(":").map(item => parseInt(item));
        const splitTotalSamedi = this.totalJourneeSamedi.split(":").map(item => parseInt(item));

        let heures = splitTotalLundi[0] + splitTotalMardi[0] + splitTotalMercredi[0] + splitTotalJeudi[0] + splitTotalVendredi[0] + splitTotalSamedi[0];
        let minutes = splitTotalLundi[1] + splitTotalMardi[1] + splitTotalMercredi[1] + splitTotalJeudi[1] + splitTotalVendredi[1] + splitTotalSamedi[1];

        while (minutes >= 60) {
            heures++;
            minutes -= 60;
        }

        return heures + ":" + (minutes || "00");
    }
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalHoraireHebdo/modalHoraireHebdo.ts